import {
  DownloadPdfParams,
  GetDocument,
  IDocument,
  LinkReference,
  ProposalPayment,
  SaveAsTemplateParams,
  SendDocumentParams,
  UpdateDocument,
  UpdateDocumentStatusParams,
} from '@gohighlevel/ghl-proposals-common'

import config from '@/config'
import { IProposalCustomerCustomNotificationSettings } from '@gohighlevel/ghl-proposals-common/src/services/CustomNotificationService'
import { requestsV2 } from '.'

export const DocumentServices = {
  getDocument: (params: GetDocument) =>
    requestsV2(config.PROPOSAL_SERVICE_URL).get<{
      document: IDocument
      links?: LinkReference[]
      whiteLabelBaseUrl?: string
      paymentInfo?: ProposalPayment
      invoiceWhiteLabelBaseUrl?: string
      notificationSettings?: IProposalCustomerCustomNotificationSettings
    }>(`/document/${params.id}`, {
      params: { locationId: params.locationId },
    }),
  updateDocument: (params: UpdateDocument) => {
    const { id, ...rest } = params
    return requestsV2(config.PROPOSAL_SERVICE_URL).put(`/document/${id}`, rest)
  },
  sendDocument: (params: SendDocumentParams) => requestsV2(config.PROPOSAL_SERVICE_URL).post('/document/send', params),
  updateDocumentStatus: (params: UpdateDocumentStatusParams) => requestsV2(config.PROPOSAL_SERVICE_URL).put('/document/status', params),
  removeDocument: (id: string) => requestsV2(config.PROPOSAL_SERVICE_URL).delete(`/document/${id}`),
  downloadPdf: (params: DownloadPdfParams) => requestsV2(config.PROPOSAL_SERVICE_URL).post('/document/download', params),
  saveAsTemplate: (params: SaveAsTemplateParams) =>
    requestsV2(config.PROPOSAL_SERVICE_URL).post(`/templates/to-template/${params.locationId}/${params.documentId}`),
  getAllCustomVariables: (locationId: string, documentId: string, contactId?: string) =>
    requestsV2(config.PROPOSAL_SERVICE_URL).get<Record<string, string>>(
      `/document/custom-values/${locationId}/${documentId}` + (contactId ? `?contactId=${contactId}` : '')
    ),
  getDocumentMetaInfo: (params: { locationId: string; documentId: string }) =>
    requestsV2(config.PROPOSAL_SERVICE_URL).get('/document/meta', { params }),

  getContentLibraryCustomContentCount: (params: { locationId: string }) =>
    requestsV2(config.PROPOSAL_SERVICE_URL).get('/templates/content-library/custom-content-count', { params }),
}
